export default __webpack_public_path__ + "static/media/CODE.46917c77.pdf";